import { useState } from 'react';
import { machinesApi } from '../../../lib/apis';
import { CreateMachineDto, Machine } from '../../../types/machines';

export function useCreateMachine(onSuccess?: (id: string) => void) {
  const [form, setForm] = useState<CreateMachineDto>({ name: '', location: '', serialNumber: '', description: '', status: 'online' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setField = <K extends keyof CreateMachineDto>(key: K, value: CreateMachineDto[K]) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const submit = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await machinesApi.post<{ data: Machine }>('/machines', form);
      onSuccess?.(res.data.id);
    } catch (e: any) {
      setError(e.message || 'Failed to create');
    } finally {
      setLoading(false);
    }
  };

  return { form, setField, submit, loading, error };
}
